import form from "./form";

const {
  formField: { firstname, lastname, email, password, repeatPassword },
} = form;

const initialValues = {
  [firstname.name]: "",
  [lastname.name]: "",
  [email.name]: "",
  [password.name]: "",
  [repeatPassword.name]: "",
};

export default initialValues;
